module.exports = __webpack_public_path__ + "img/20190612162402525.99f808eb.png";